import React, { useState, useEffect } from 'react';
import './EditCredorModal.css';
import { MdClose, MdPerson, MdBadge } from 'react-icons/md';
import { getToken } from '../../../../../services/api';

const EditCredorModal = ({ isOpen, onClose, precatorio, state, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    document_used: ''
  });

  useEffect(() => {
    if (isOpen && precatorio) {
      setFormData({
        nome: precatorio.nome || '',
        document_used: precatorio.document_used || ''
      });
      setError(null);
    }
  }, [isOpen, precatorio]);

  const formatCPF = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 11) {
      return cleaned
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return value;
  };

  const formatCNPJ = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 14) {
      return cleaned
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }
    return value;
  };

  const handleDocumentChange = (value) => {
    const cleaned = value.replace(/\D/g, '');
    let formatted = cleaned;
    
    if (cleaned.length <= 11) {
      formatted = formatCPF(cleaned);
    } else if (cleaned.length <= 14) {
      formatted = formatCNPJ(cleaned);
    }
    
    setFormData(prev => ({ ...prev, document_used: formatted }));
  };

  const handleSave = async () => {
    if (!formData.nome.trim()) {
      setError('Nome do credor é obrigatório');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const API_URL = process.env.NODE_ENV === 'production' 
        ? process.env.REACT_APP_VERCEL_API_URL 
        : process.env.REACT_APP_LOCAL_API_URL;

      const updateData = {};
      
      if (formData.nome.trim() !== precatorio.nome) {
        updateData.nome = formData.nome.trim();
      }
      
      if (formData.document_used.trim() !== precatorio.document_used) {
        updateData.document_used = formData.document_used.trim();
      }

      if (Object.keys(updateData).length === 0) {
        onClose();
        return;
      }

      const response = await fetch(`${API_URL}/contacted-precatorios/${state}/${precatorio._id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar dados do credor');
      }

      if (onSuccess) {
        onSuccess();
      }

      onClose();

    } catch (err) {
      setError(err.message || 'Erro ao salvar alterações');
      console.error('Save error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !precatorio) return null;

  return (
    <div className="edit-credor-modal-overlay" onClick={onClose}>
      <div className="edit-credor-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Editar Dados do Credor</h2>
          <button className="close-button" onClick={onClose} disabled={loading}>
            <MdClose />
          </button>
        </div>

        <div className="modal-body">
          <div className="precatorio-info">
            <span className="info-label">Precatório:</span>
            <span className="info-value">{precatorio.numero_precatorio}</span>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-section">
            <div className="section-header">
              <MdPerson className="section-icon" />
              <h3>Nome do Credor</h3>
            </div>
            <div className="form-group">
              <input
                type="text"
                value={formData.nome}
                onChange={(e) => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                placeholder="Nome completo do credor..."
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-section">
            <div className="section-header">
              <MdBadge className="section-icon" />
              <h3>CPF/CNPJ</h3>
            </div>
            <div className="form-group">
              <input
                type="text"
                value={formData.document_used}
                onChange={(e) => handleDocumentChange(e.target.value)}
                placeholder="000.000.000-00 ou 00.000.000/0000-00"
                maxLength="18"
                disabled={loading}
              />
              <span className="input-hint">
                Digite apenas números - a formatação é automática
              </span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="cancel-button" 
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button 
            className="save-button" 
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCredorModal;
